var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { ZdsUpload } from '@zig-design-system/ui-components-react';
import { Label } from './elements/Label';
import { usePowermailSettings } from '../../context/PowermailContext';
import Translation from '../../../Shared/components/Translation';
export const File = ({ field, onChange, value }) => {
    const [existingFiles, setExistingFiles] = useState();
    const powermailSettings = usePowermailSettings();
    useEffect(() => {
        if (existingFiles) {
            return;
        }
        else if (!value || typeof value !== 'object') {
            setExistingFiles([]);
        }
        else {
            Promise.all(Object.values(value).map((fileId) => fetch(`/?type=1732700802&tx_zigsitepackage_uploadhandler[action]=getFile&id=${fileId}`).then((response) => response.json())))
                .then((data) => {
                setExistingFiles(data);
            })
                .catch((e) => {
                console.error(e);
                setExistingFiles([]);
            });
        }
    }, [value]);
    const handleChange = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const files = yield e.target.getFiles();
        const fileIds = [];
        for (const file of files) {
            // File has not yet uploaded
            if (!((_a = file.xhr) === null || _a === void 0 ? void 0 : _a.response)) {
                continue;
            }
            const fileId = JSON.parse(file.xhr.response).id;
            fileIds.push(fileId);
        }
        onChange(field, fileIds, files);
    });
    if (!existingFiles) {
        return null;
    }
    return (React.createElement(ZdsUpload, { placeholderClick: Translation({ item: 'powermail.upload.click' }).join(''), placeholderDrag: Translation({ item: 'powermail.upload.drag' }).join(''), placeholderOr: Translation({ item: 'powermail.upload.or' }).join(''), acceptedfiles: powermailSettings.acceptedFiles, maxfilesize: powermailSettings.maxFileSize, maxTotalFileSize: powermailSettings.maxTotalFileSize, url: "/?type=1644240693", required: field.mandatory, name: field.name, id: `powermail_field_${field.marker}`, onZdsFileUploadCompleted: handleChange, onZdsChange: handleChange, selectedFilesTitlePlural: Translation({ item: 'powermail.upload.selectedFilesTitlePlural' }).join(''), selectedFilesTitleSingular: Translation({ item: 'powermail.upload.selectedFilesTitleSingular' }).join(''), existingFiles: existingFiles },
        React.createElement(Label, { field: field })));
};
